
import React, { Component } from 'react';
import {
    FacebookShareCount,
    PinterestShareCount,
    VKShareCount,
    OKShareCount,
    RedditShareCount,
    TumblrShareCount,
    FacebookShareButton,
    FacebookMessengerShareButton,
    FacebookMessengerIcon,
    LinkedinShareButton,
    TwitterShareButton,
    PinterestShareButton,
    VKShareButton,
    OKShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    RedditShareButton,
    EmailShareButton,
    TumblrShareButton,
    LivejournalShareButton,
    MailruShareButton,
    ViberShareButton,
    WorkplaceShareButton,
    LineShareButton,
    WeiboShareButton,
    PocketShareButton,
    InstapaperShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    PinterestIcon,
    VKIcon,
    OKIcon,
    TelegramIcon,
    WhatsappIcon,
    RedditIcon,
    TumblrIcon,
    MailruIcon,
    EmailIcon,
    LivejournalIcon,
    ViberIcon,
    WorkplaceIcon,
    LineIcon,
    PocketIcon,
    InstapaperIcon,
    WeiboIcon,
} from 'react-share';

//import './Demo.css';

class Share extends Component {
    render() {
	
	const {title, url} = this.props;
	const shareUrl = url !=null ? url : window.location.href;
	return (
	    <div className="Demo__container">
		<div className="share-network">
		    <FacebookShareButton
			url={shareUrl}
			quote={title}
			className="share-network__share-button"
		    >
			<FacebookIcon size={32} round />
		    </FacebookShareButton>
		</div>

		<div className="share-network">
		    <TwitterShareButton
			url={shareUrl}
			title={title}
			className="share-network__share-button"
		    >
			<TwitterIcon size={32} round />
		    </TwitterShareButton>
		</div>

		<div className="share-network">
		    <TelegramShareButton
			url={shareUrl}
			title={title}
			className="share-network__share-button"
		    >
			<TelegramIcon size={32} round />
		    </TelegramShareButton>
		</div>

		<div className="share-network">
		    <WhatsappShareButton
			url={shareUrl}
			title={title}
			separator=":: "
			className="share-network__share-button"
		    >
			<WhatsappIcon size={32} round />
		    </WhatsappShareButton>
		</div>

		<div className="share-network">
		    <LinkedinShareButton url={shareUrl} className="share-network__share-button">
			<LinkedinIcon size={32} round />
		    </LinkedinShareButton>
		</div>


		<div className="share-network">
		    <EmailShareButton
			url={shareUrl}
			subject={title}
			body="body"
			className="share-network__share-button"
		    >
			<EmailIcon size={32} round />
		    </EmailShareButton>
		</div>

	    </div>
	);
    }
}

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share/index.jsx